import { boolean, dateOnly, double, InferSubmit, mixed, object } from '@if/core/yup'
import { CalculateNumberOfPaymentsToClearOverdueAmountResult } from '@src/api/loan/loan-api'

/**
 * The catch-up answer the backend worked out for the amount and start date on screen, held on
 * the form so Confirm applies the one the agent is looking at rather than firing a fresh call
 * on submit. Only catch-up mode needs it, which is what the `when` below says.
 */
const catchUpCalculation = () =>
  mixed<CalculateNumberOfPaymentsToClearOverdueAmountResult>().nullable().defined().default(null)

/**
 * `isCatchUpMode` is not a field the agent fills — it is the opener's intent, seeded from the
 * open-time props, and the two rules that differ between the two flows read it from there.
 */
export const batchUpdatePaymentsSchema = object({
  isCatchUpMode: boolean().required().default(false),
  amount: double().required().moreThan(0),
  fromPaymentDate: dateOnly()
    .nullable()
    .defined()
    .default(null)
    .when('isCatchUpMode', { is: true, then: (schema) => schema.required() }),
  catchUpCalculation: catchUpCalculation().when('isCatchUpMode', {
    is: true,
    then: (schema) => schema.required(),
  }),
})

export type BatchUpdatePaymentsSchemaType = InferSubmit<typeof batchUpdatePaymentsSchema>
